import { getDiffTime } from '@/helpers/date';
import { DEFAULT_POSTGRAD_CONTRACT_DURATION } from '@/helpers/postgradContractExtension/constants';
import { ChimeraContractModel, ChimeraContractInfo } from './ChimeraContractModel';

export interface ChimeraCourseInfo {
  _id: string;
  name: string;
  slug: string;
  dexCourseId?: number;
  dexCourseAvailability: boolean;
  shouldRedirectToClassrooms: boolean;
  category: {
    name: string;
    slug: string;
  };
  contractByUser: ChimeraContractInfo | null;
  expiredContractsByUser?: ChimeraContractInfo[] | null;
}

export class ChimeraCourseModel {
  _id: string;

  name: string;

  slug: string;

  dexCourseId?: number;

  dexCourseAvailability: boolean;

  shouldRedirectToClassrooms: boolean;

  category: {
    name: string;
    slug: string;
  };

  contractByUser: ChimeraContractModel | null;

  expiredContractsByUser: ChimeraContractModel[] | null;

  constructor(chimeraCourse: ChimeraCourseInfo) {
    // eslint-disable-next-line no-underscore-dangle
    this._id = chimeraCourse._id;
    this.name = chimeraCourse.name;
    this.slug = chimeraCourse.slug;
    this.dexCourseId = chimeraCourse.dexCourseId;
    this.dexCourseAvailability = chimeraCourse.dexCourseAvailability;
    this.shouldRedirectToClassrooms = chimeraCourse.shouldRedirectToClassrooms;
    this.category = chimeraCourse.category;
    this.contractByUser =
      chimeraCourse.contractByUser &&
      new ChimeraContractModel({
        id: chimeraCourse.contractByUser.id,
        startDate: chimeraCourse.contractByUser.startDate,
        expirationDate: chimeraCourse.contractByUser.expirationDate,
      });
    this.expiredContractsByUser = !chimeraCourse.expiredContractsByUser
      ? null
      : chimeraCourse.expiredContractsByUser.map(
          (c) =>
            new ChimeraContractModel({
              id: c.id,
              startDate: c.startDate,
              expirationDate: c.expirationDate,
            }),
        );
  }

  get mostRecentExpiredCourseContract(): ChimeraContractModel | null {
    if (!this.expiredContractsByUser?.length) return null;

    const expiredContractsSortedByStartDate = this.expiredContractsByUser
      .filter(
        (c) =>
          getDiffTime(c.expirationDate, c.startDate).months >= DEFAULT_POSTGRAD_CONTRACT_DURATION,
      )
      .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());

    return expiredContractsSortedByStartDate[expiredContractsSortedByStartDate.length - 1];
  }

  isExpired(): boolean {
    return this.contractByUser === null && !!this.expiredContractsByUser?.length;
  }
}
